routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.templates', {
      url: __env.routes.templates,
      template: `<templates sh-ctrl="shCtrl"></templates>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/templates/templates.config.js